import {
  Box,
  ListItem,
  ListItemButton as MUIListItemButton,
} from '@mui/material';
import { styled } from '@mui/material/styles';
import type { Capabilities } from '@/entities/session';
import { ViewAccessType } from '@/entities/session';
import { Checkbox } from '@/shared/ui';

const ListItemButton = styled(MUIListItemButton)(({ theme }) => ({
  display: 'flex',
  gap: theme.spacing(1.25),
  lineHeight: '22px',
  fontSize: '14px',
  padding: `${theme.spacing(1.25)} ${theme.spacing(2)}`,
  color: 'var(--neutral-700)',

  '&.Mui-selected': {
    backgroundColor: 'transparent',
  },

  '&:hover, &:focus-visible': {
    backgroundColor: 'var(--accent-100)',
  },
}));

interface Props {
  value: Capabilities;
  onChange: (value: Capabilities) => void;
}

const ITEMS = [
  { key: 'userManagement' as const, label: 'User Management' },
  { key: 'mcpAccess' as const, label: 'MCP Access' },
];

export function CapabilitiesPanel({ value, onChange }: Props) {
  const handleChange = (key: keyof Capabilities) => () => {
    const next =
      value[key] === ViewAccessType.DENIED ? ViewAccessType.ALLOWED : ViewAccessType.DENIED;
    onChange({ ...value, [key]: next });
  };

  return (
    <Box component="ul" sx={{ m: 0, p: 0, width: '100%' }}>
      {ITEMS.map(({ key, label }) => (
        <ListItem key={key} disablePadding>
          <ListItemButton
            selected={value[key] !== ViewAccessType.DENIED}
            onClick={handleChange(key)}
          >
            <Checkbox
              color="primary"
              sx={{ p: 0 }}
              checked={value[key] !== ViewAccessType.DENIED}
              tabIndex={-1}
              disableRipple
              inputProps={{ 'aria-label': label }}
            />
            {label}
          </ListItemButton>
        </ListItem>
      ))}
    </Box>
  );
}
